import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Compact "disabled" indicator: a small muted dot with a tooltip, so the
 * pipeline name keeps the available width (no truncation to «Отм…»). The dot
 * is decorative; the title/aria-label carry the meaning. Extracted
 * byte-identical from the conversation rail's pipelines panel and
 * `bulk-pipeline-dialog.tsx` (kit-extraction Wave 6, task 6); both call sites
 * migrated onto this component in Wave 7.
 */
export function PipelineDisabledDot() {
    return (_jsx("span", { className: "h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--color-text-muted)]", title: "\u041F\u0430\u0439\u043F\u043B\u0430\u0439\u043D \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D", "aria-label": "\u041F\u0430\u0439\u043F\u043B\u0430\u0439\u043D \u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D", role: "img" }));
}
//# sourceMappingURL=pipeline-disabled-dot.js.map